import styled from '@emotion/styled'
import { Equaliser } from './Components/Equaliser/Equaliser'
import { breakpointMax } from '../../../../__styling/style-functions'
import { VolumeControl } from './Components/VolumeControl/VolumeControl'
import { ControlButton } from './Components/ControlButton/ControlButton'
import { Countdown } from './Components/Countdown/Countdown'
import { colors } from '../../../../__styling/settings/colors'
import { OnAirNotice } from './Components/OnAirNotice/OnAirNotice'
import { calcRem } from '../../../../__styling/style-functions/calc-rem'

export const StyledTheWestLivePlayerWrapper = styled('div')({
    display: 'flex',
    height: '100%',
    alignItems: 'center',
})

export const StyledTheWestLivePlayerButton = styled(ControlButton)()
export const StyledTheWestLivePlayerBigButton = styled(ControlButton)({
    margin: calcRem(5, 0),
})

export const StyledTheWestLivePlayerCountdown = styled(Countdown)({
    marginLeft: calcRem(15),
    fontSize: calcRem(20),
    color: colors.white,
})

export const StyledTheWestLivePlayerVolumeGroup = styled('div')({
    paddingLeft: calcRem(4),
})

export const StyledTheWestLivePlayerEqualiser = styled(Equaliser)({
    marginLeft: calcRem(15),
})

export const StyledTheWestLiveOnAirNotice = styled(OnAirNotice)({
    marginLeft: calcRem(15),
})

export const StyledTheWestLivePlayerVolume = styled(VolumeControl)({
    minWidth: calcRem(100),
    marginLeft: calcRem(10),
    [breakpointMax('xs')]: {
        display: 'none',
    },
})
